import React from 'react';

const CancelContractIcon = ({ fill = "currentColor", className = "bi bi-x-lg", width = "16", height = "16", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} className={className} viewBox="0 0 16 16" {...props}>
        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
    </svg>
);

export default CancelContractIcon;